import React from 'react';
import { Space, Button, Tooltip, Popconfirm } from 'antd';
import { 
  EyeOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  PlusOutlined,
  DollarOutlined,
  BellOutlined,
  FileExcelOutlined,
  UploadOutlined,
  DownloadOutlined,
  PrinterOutlined,
  ShareAltOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined
} from '@ant-design/icons';
import permissionService from '../../services/permissionService';

const ActionButtons = ({
  module, // Tên module (factories, tenants, contracts, etc.)
  onView,
  onAdd,
  onEdit,
  onDelete,
  onPay,
  onRemind,
  onImport,
  onExport,
  onPrint,
  onShare,
  onApprove,
  onReject,
  onSync,
  record,
  showAdd = true,
  showView = true,
  showEdit = true,
  showDelete = true,
  showPay = false,
  showRemind = false,
  showImport = false,
  showExport = false,
  showPrint = false,
  showShare = false,
  showApprove = false,
  showReject = false,
  showSync = false,
  addText = 'Thêm mới',
  viewText = 'Xem chi tiết',
  editText = 'Sửa',
  deleteText = 'Xóa',
  payText = 'Thanh toán',
  remindText = 'Gửi nhắc nhở',
  importText = 'Import',
  exportText = 'Export',
  printText = 'In',
  shareText = 'Chia sẻ',
  approveText = 'Duyệt',
  rejectText = 'Từ chối',
  syncText = 'Đồng bộ',
  deleteConfirmTitle = 'Xác nhận xóa',
  deleteConfirmDescription = 'Bạn có chắc chắn muốn xóa mục này không?',
  deleteConfirmOkText = 'Xóa',
  deleteConfirmCancelText = 'Hủy',
  disabled = false,
  loading = false
}) => {
  const canView = permissionService.checkPermission(`view_${module}`);
  const canAdd = permissionService.checkPermission(`add_${module}`);
  const canEdit = permissionService.checkPermission(`edit_${module}`);
  const canDelete = permissionService.checkPermission(`delete_${module}`);
  const canPay = permissionService.checkPermission(`pay_${module}`);
  const canRemind = permissionService.checkPermission(`remind_${module}`);
  const canImport = permissionService.checkPermission(`import_${module}`);
  const canExport = permissionService.checkPermission(`export_${module}`);
  const canPrint = permissionService.checkPermission(`print_${module}`);
  const canShare = permissionService.checkPermission(`share_${module}`);
  const canApprove = permissionService.checkPermission(`approve_${module}`);
  const canReject = permissionService.checkPermission(`reject_${module}`);
  const canSync = permissionService.checkPermission(`sync_${module}`);

  return (
    <Space size="middle">
      {showAdd && canAdd && (
        <Tooltip title={addText}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onAdd}
            disabled={disabled}
            loading={loading}
          >
            {addText}
          </Button>
        </Tooltip>
      )}
      
      {showView && canView && (
        <Tooltip title={viewText}>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => onView(record)}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}
      
      {showEdit && canEdit && (
        <Tooltip title={editText}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}
      
      

      {showPay && canPay && (
        <Tooltip title={payText}>
          <Button
            type="primary"
            icon={<DollarOutlined />}
            onClick={() => onPay(record)}
            disabled={disabled}
            loading={loading}
            style={{ backgroundColor: '#faad14', borderColor: '#faad14' }}
          />
        </Tooltip>
      )}

      {showRemind && canRemind && (
        <Tooltip title={remindText}>
          <Button
            type="primary"
            icon={<BellOutlined />}
            onClick={() => onRemind(record)}
            disabled={disabled}
            loading={loading}
            style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
          />
        </Tooltip>
      )}
{showDelete && canDelete && (
        <Popconfirm
          title={deleteConfirmTitle}
          description={deleteConfirmDescription}
          onConfirm={() => onDelete(record)}
          okText={deleteConfirmOkText}
          cancelText={deleteConfirmCancelText}
          okButtonProps={{ danger: true }}
        >
          <Tooltip title={deleteText}>
            <Button
              danger
              icon={<DeleteOutlined />}
              disabled={disabled}
              loading={loading}
            />
          </Tooltip>
        </Popconfirm>
      )}
      {showImport && canImport && (
        <Tooltip title={importText}>
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={onImport}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}

      {showExport && canExport && (
        <Tooltip title={exportText}>
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={onExport}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}

      {showPrint && canPrint && (
        <Tooltip title={printText}>
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => onPrint(record)}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}

      {showShare && canShare && (
        <Tooltip title={shareText}>
          <Button
            type="primary"
            icon={<ShareAltOutlined />}
            onClick={() => onShare(record)}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}

      {showApprove && canApprove && (
        <Tooltip title={approveText}>
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={() => onApprove(record)}
            disabled={disabled}
            loading={loading}
            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
          />
        </Tooltip>
      )}

      {showReject && canReject && (
        <Tooltip title={rejectText}>
          <Button
            type="primary"
            icon={<CloseCircleOutlined />}
            onClick={() => onReject(record)}
            disabled={disabled}
            loading={loading}
            style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
          />
        </Tooltip>
      )}

      {showSync && canSync && (
        <Tooltip title={syncText}>
          <Button
            type="primary"
            icon={<SyncOutlined />}
            onClick={() => onSync(record)}
            disabled={disabled}
            loading={loading}
          />
        </Tooltip>
      )}
    </Space>
  );
};

export default ActionButtons; 